import { ReportElementType } from '@/modules/ta/reportstudio/reportstudio.constants';
import { ReportStudioImageElementMetadata } from '@/modules/ta/reportstudio/models/ReportStudioImageElementMetadata';
import { ReportStudioIconElementMetadata } from '@/modules/ta/reportstudio/models/ReportStudioIconElementMetadata';
import { ReportStudioShapeElementMetadata } from '@/modules/ta/reportstudio/models/ReportStudioShapeElementMetadata';
import { ReportStudioTextElementMetadata } from '@/modules/ta/reportstudio/models/element/ReportStudioTextElementMetadata';
import { ReportStudioElementMetadata } from '@/modules/ta/reportstudio/models/ReportStudioElementMetadata';

export class ReportStudioElementMetadataFactory {
  /**
   *
   * @param element
   * @returns {ReportStudioElementMetadata}
   */
  static build(element) {
    switch (element.type) {
      case ReportElementType.IMAGE:
        return new ReportStudioImageElementMetadata(element.metadata);
      case ReportElementType.ICON:
        return new ReportStudioIconElementMetadata(element.metadata);
      case ReportElementType.TEXT:
        return new ReportStudioTextElementMetadata(element.metadata);
      case ReportElementType.SHAPE:
        return new ReportStudioShapeElementMetadata(element.metadata);
      default:
        return new ReportStudioElementMetadata(element.metadata);
    }
  }
}
